/**
 *  Konwersja bajtów
 *
 * @param {number} bytes
 * @returns
 */
export const formatSize = (bytes: number) => {
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const kilo = 1024;
  let pow = 0;
  while (bytes > kilo) {
    bytes = bytes / kilo;
    pow++;
  }
  return `${bytes.toFixed(2)} ${sizes[pow]}`;
};
